// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#cookies-banner{position:fixed;bottom:0;left:0;right:0;background:#1b232e;opacity:0.9;text-align:center;color:#fff;z-index:99999}#cookies-banner #cookies-banner-content{align-items:center}#cookies-banner #cookies-banner-content *{margin-left:5px;margin-right:5px}@media print{#cookies-banner{display:none}}\n", ""]);
// Exports
module.exports = exports;
